import { combineReducers } from "redux"
import AccessControlMgmtReducer from "./AccessControlMgmt"


export default combineReducers({
    mgmt: AccessControlMgmtReducer
})
